const selectMatchDescriptionBoxContent = phrases => ({
  title: phrases.matchDescHighTitle,
  paragraphs: [phrases.matchDescHighBottomP],
});

export default selectMatchDescriptionBoxContent;
